module.exports = __webpack_public_path__ + "img/کارت-ویزیت-لمینت-مخملی-برجسته.def9e012.png";